import {BOT_CONV_MESSAGE_TYPE} from '../../../../consts/common-consts';
import ChatDate from "../../../chat-date";
import { bubbleClass } from '../bubble-style';

export default function TextListMessage({senderType, message, date}) {
  const isBot = senderType === BOT_CONV_MESSAGE_TYPE;
  const items = Array.isArray(message) ? message : [message];

  return (
      <div className={`flex flex-col gap-1 ${isBot ? 'items-start' : 'items-end'}`}>
          {items.map((msg, mi)=>
              <div key={mi} className={bubbleClass(isBot)}>
                  <p className='whitespace-pre-wrap break-words'>{msg}</p>
                  {/* Only the last bubble is stamped: one timestamp per turn
                      reads as a single message, which is what a text list is. */}
                  {mi === items.length - 1 && <ChatDate date={date} isBot={isBot} />}
              </div>
          )}
      </div>
  );
}
